import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShareAndroid = () => {
  return (
    <g>
      <path d="M12.75 0a3.25 3.25 0 1 1-2.477 5.354L6.417 7.268a3.26 3.26 0 0 1-.003 1.478l3.842 1.92a3.25 3.25 0 1 1-.67 1.341l-3.844-1.92a3.25 3.25 0 1 1 .01-4.163L9.59 4.017A3.25 3.25 0 0 1 12.75 0zm0 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5zm-9.5-4.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5zm9.5-4.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5z" />
    </g>
  );
};

export default withIcon(IconShareAndroid);
